<template>
    <div class="body">
            <p  class="font1" style="padding-top: 8vh;">让我们在新的一年，勇敢追梦，持续前行！</p>
            <!-- <p  class="font1" style="padding-top: 1vh;">修炼心灵，启迪前程。</p> -->

            <p class="font2" style="padding-top: 2vh;text-align: left;">2025年第一季度富学宝典上热门课程：</p>
            <div style="width: 90%;margin: 0 auto;margin-top: 2vh;">
                <ul v-for="(item,index) in mergeBook.slice(0,3)" :key="index">
                    <li @click="redirectToRecommendBook(index)">{{item.Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg"></i></li>
                </ul>
            </div>

            <p class="font2" v-if="uncompletedLink.length>0" style="padding-top: 2vh;text-align: left;">以下课程已学习过半，您离完成目标只差一步之遥：</p>
            <div style="width: 90%;margin: 0 auto;margin-top: 1vh;">
                <ul v-for="(item,index) in mergeBook.slice(3)" :key="index">
                    <li @click="redirectToRecommendBook(index)">{{item.Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg"></i></li>
                </ul>
            </div>
            
    </div>
</template>


<script>

export default {
      props: ["ReportData"],
      components:{},
      data() {
        return {
            topRecommendLink:'',
            uncompletedLink:[],
            mergeBook:''
        }
      },
      created(){
        this.topRecommendLink=JSON.parse(this.ReportData.topRecommendLink)
        this.uncompletedLink=JSON.parse(this.ReportData.uncompletedLink)
        console.log(this.uncompletedLink)
        this.mergeBook=this.topRecommendLink.concat(this.uncompletedLink)
    //   console.log(this.mergeBook,'书');
      },
      methods:{
        redirectToRecommendBook(id){
            const book=this.mergeBook[id]
            // console.log(book,'推荐课程');
            // const url=book.link
            const view={
                clickCourseName:book.Name,
                clickCourseLink:book.link
            }
            this.$emit('redirectToRecommendBook',view)  
        },
      }
    }
</script>
  
<style scoped>
.body {
    background: 
                url("../../assets/25March/logo.png") right  top  no-repeat,
                url("../../assets/25March/bg.jpg")  no-repeat;
    background-size:100% 100%,cover;
    width: 100%;
    height: 100vh;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    /* text-align: center; */
}
li {
    align-items: center;
    margin-bottom: -13px; /* 可调整列表项之间的间距 */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}
.font1 {
    width: 96%;
    margin: 0 auto;
    /* text-align: center; */
    font-size: 20px;
    color: #64892f;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}d
.font2 { 
    width: 90%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #000;
    font-size: 18px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 30px;
    font-weight: bold;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #953b5d;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

</style>